import React, { useState } from 'react';

// This component now only collects email & phone.
// It provides two buttons: Continue (go to next step) and Send Verification Code (prepares user for OTP step).
// Actual OTP entry will occur on the later OTP step using static code 000000.
const AccountVerification = ({ data, updateData, onNext }) => {
  const isFormValid = data.email && data.phone && data.phone.replace(/\D/g, '').length === 11 && data.smsConsent;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Account Verification</h2>
        <p className="text-sm text-gray-600">
          Enter your email and phone number. You can continue now; we will verify both with OTP at the end.
        </p>
      </div>

      <div className="space-y-4">
        {/* Email */}
        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-orange-500 mr-2"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
            Email Address
          </label>
          <input
            type="email"
            placeholder="company@example.com"
            value={data.email}
            onChange={(e) => updateData({ email: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-400 transition"
          />
        </div>

        {/* Phone */}
        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-orange-500 mr-2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
            Phone Number
          </label>
          <div className="flex rounded-lg border border-gray-300 overflow-hidden focus-within:ring-2 focus-within:ring-orange-300 focus-within:border-orange-400 transition">
            <span className="flex items-center px-3 bg-gray-100 text-gray-600 text-sm font-semibold border-r border-gray-300 select-none">+1</span>
            <input
              type="tel"
              placeholder="555 123 4567"
              maxLength={10}
              value={data.phone.replace(/^\+1/, '')}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                updateData({ phone: `+1${digits}` });
              }}
              className="flex-1 px-4 py-3 text-sm focus:outline-none bg-white"
            />
          </div>
          <div className="mt-4 flex items-start gap-3 py-3 px-4 bg-orange-50 rounded-lg border border-orange-100">
            <input
              type="checkbox"
              id="smsConsent"
              checked={data.smsConsent}
              onChange={(e) => updateData({ smsConsent: e.target.checked })}
              className="mt-1 h-4 w-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500 cursor-pointer"
            />
            <label htmlFor="smsConsent" className="text-[11px] text-gray-600 leading-relaxed cursor-pointer select-none">
              By providing your mobile number, you agree to receive transactional <strong>SMS</strong> messages from My Move Advisor including verification codes and account-related notifications. Message frequency varies. Message & data rates may apply. Reply <strong>STOP</strong> to opt out or <strong>HELP</strong> for assistance.
            </label>
          </div>
        </div>

        <div className="flex gap-3 pt-2">
          <button
            onClick={onNext}
            disabled={!isFormValid}
            className="w-full bg-gradient-to-r from-orange-400 to-orange-600 text-white py-3 rounded-lg font-semibold hover:from-orange-500 hover:to-orange-700 transition disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountVerification;
